export default __webpack_public_path__ + "8e275bcf2d032e1fc2d336d5cd6d880c.png";